import { Environment } from 'src/app/interfaces';

export const environment: Environment = {
  production: false,
  name: 'Mijn Buurtvervoer Dev',
  firebase: {
    apiKey: 'AIzaSyCaTdCKfVG0kVAjbfNKXMhfRQfzBlWUiu8',
    authDomain: 'wemaron-buurtvervoer.firebaseapp.com',
    projectId: 'wemaron-buurtvervoer',
    storageBucket: 'wemaron-buurtvervoer.appspot.com',
    messagingSenderId: '451062674757',
    appId: '1:451062674757:web:9345a6bfc259cd36cefa2c',
  },
  functionsUrl: 'https://europe-west1-wemaron-buurtvervoer.cloudfunctions.net',
  defaultOrgId: 'wemaron',
  defaultRoute: {
    id: 'profile',
    path: 'profile',
  },
  routes: ['auth', 'set', 'profile', 'pay', 'payLanding', 'firstTime'],
};
